const IP = "//admin.aioffice.ink/api";
// const IP = "//localhost.admin.corehold.com";
export default {
    getChildren(data){
        console.log(data)
        return {
            url:IP+"/content/v1/article/get-detail",
            params:{
                a_title:data.a_id,
                lang: data.lang,
            }
        }
    }
}